/**
 * Created with IntelliJ IDEA.
 * User: elinar
 * Date: 12/9/14
 * Time: 7:38 PM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    var LE = require("app"),
        CP_CONST = require("connection-const"),
        ChatTabLayout = require("connection-views/layouts/chatTab/ChatTabLayout"),
        ChatApiController = require("connection-controllers/chatTab/ChatApiController"),
        ChatWindowController = require("connection-controllers/chatTab/ChatWindowController"),
        MessagingNotificationsController = require("connection-controllers/chatTab/MessagingNotificationsController"),
        ChatNotificationsController = require("connection-controllers/chatTab/ChatNotificationsController"),
        AgentMessagingModel = require("connection-models/chatTab/AgentMessagingModel"),
        ChatStateModel = require("connection-models/chatTab/ChatStateModel"),
        ChatContactsController = require("connection-controllers/chatTab/ChatContactsController"),
        ChatStartDataController = require("connection-controllers/chatTab/ChatStartDataController"),
        SurveyWindowController = require("connection-controllers/chatTab/SurveyWindowController"),
        media = require("media"),
        ChatTabController = {};

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {

        //todo: raise event about new lines

        var logger = LEConnection.logger;

        ChatTabController = Marionette.Controller.extend({

            initialize: function (options) {
                logger.debug("initialize : entered", "ChatTabController.initialize");

                this._connectionPanelContextModel = options.connectionPanelContextModel;
                this._chatChannel = media.channel("cp_chat");

                this._bindEvents();
                this._showLayout();
                this._initializeChat();

                this._chatTabState = CP_CONST.CHAT_TAB_STATES.CONTACTS_LIST;
           },

            _bindEvents: function () {

                var cVent = this._chatChannel.vent;


                this.listenTo(cVent, "chatConnection:chat:close", this._showChatContacts);
                this.listenTo(cVent, "chatConnection:chat:starting chatConnection:chat:chatting chatConnection:chat:waiting", this._showChatWindow);
                this.listenTo(cVent, "cpChatUI:error", this._onChatTabError);
                this.listenTo(cVent, "cpChatUI::survey:show", this._showSurveyWindow);
                this.listenTo(cVent, "cpChatUI::survey:close", this._closeSurveyWindow);

                this.listenTo(cVent, "cpChatUI::showRegion:chatWindow", this._showChatWindowRegion);
                this.listenTo(cVent, "cpChatUI::showRegion:chatContacts", this._showChatContactsRegion);
                this.listenTo(cVent, "cpChatUI::showRegion:chatSurvey", this._showChatSurveyRegion);
                this.listenTo(LE.sessionManager.model, "destroy", this._onAppLogout);
                this._chatChannel.reqres.setHandler("cpChatUI::getChatTabState", this._getChatTabState, this);
            },

            _initializeChat: function () {

                this._messagingAgent = new AgentMessagingModel();
                this._stateModel = new ChatStateModel(this._chatChannel);

                this._chatStartDatacontroller = new ChatStartDataController({chatChannel: this._chatChannel});
                this._chatApiController = new ChatApiController({chatChannel: this._chatChannel, contextModel: this._connectionPanelContextModel, stateModel: this._stateModel});
                this._chatWindowController = new ChatWindowController({chatChannel: this._chatChannel, contextModel: this._connectionPanelContextModel, agentMessagingModel:this._messagingAgent});
                this._messagingNotificationsController = new MessagingNotificationsController({chatChannel: this._chatChannel, contextModel: this._connectionPanelContextModel, agentMessagingModel:this._messagingAgent});
                this._chatNotificationsController = new ChatNotificationsController({chatChannel: this._chatChannel, contextModel: this._connectionPanelContextModel});
                this._chatContactsController = new ChatContactsController({chatChannel: this._chatChannel, contextModel: this._connectionPanelContextModel});
                this._surveyWindowController = new SurveyWindowController({chatChannel: this._chatChannel});

                this._chatChannel.vent.trigger("chatConnection:initialize:request");
            },

            _showLayout: function () {
                this._chatTabLayout = new ChatTabLayout({chatVent: this._chatChannel.vent});
                LEConnection.vent.trigger("MainContainerController::showRegion:chatRegion", {view: this._chatTabLayout});
            },

            _showChatWindow: function (info) {
                logger.debug("received request to show the chat window ui", "ChatTabController._showChatWindow", info);

                if (info.state === info.states.CHATTING || //if already chatting or if waiting/resuming but chat not initiated by user (resume) then show the chat UI
                    (info.state !== info.states.CHATTING && info.initSource !== CP_CONST.CHAT_INITIATED_SOURCE.USER)) {

                    this._chatChannel.vent.trigger("cpChatUI::layout:chat:show", info);
                    this._chatTabState = CP_CONST.CHAT_TAB_STATES.CHAT_WINDOW;
                } else {
                    this._chatChannel.vent.trigger("cpChatUI::showRegion:chatContacts", { view: this._chatWindowController._chatContactsLayout} );
                }
            },

            _showChatContacts: function () {
                logger.debug("received request to show the contacts ui", "ChatTabController._showChatContacts");
                this._chatChannel.vent.trigger("cpChatUI::layout:contacts:show");
                this._chatTabState = CP_CONST.CHAT_TAB_STATES.CONTACTS_LIST;
            },

            _showSurveyWindow: function () {
                logger.debug("received request to show the survey ui", "ChatTabController._showSurveyWindow");
                this._chatChannel.vent.trigger("cpChatUI::layout:survey:show");
                this._chatTabState = CP_CONST.CHAT_TAB_STATES.SURVEY_WINDOW;
            },

            /**
             *
             * @param options = {showState (CP_CONST.CHAT_TAB_STATES)
             * @private
             */
            _closeSurveyWindow: function (options) {
                logger.debug("received request to close survey", "ChatTabController._closeSurveyWindow", options);
                var userClosedChat = this._chatChannel.reqres.request("cpChatUI::chatWindowController:userClosedChat");
                var chatInProgress = this._chatChannel.reqres.request("cpChatUI::chatWindowController::chatInProgress");

                if (userClosedChat) { //leave the chat content only if there is no survey and the user wasnt the one to close the chat
                    this._chatChannel.command("cpChatUI::chatWindowController:exitChatUI", options.retrieved);
                }
                var gotoState = userClosedChat||!chatInProgress ? CP_CONST.CHAT_TAB_STATES.CONTACTS_LIST : CP_CONST.CHAT_TAB_STATES.CHAT_WINDOW;
                var showRegion;

                switch (gotoState) {        //based on the options decide where to go - contacts or chat
                    case CP_CONST.CHAT_TAB_STATES.CONTACTS_LIST:
                        showRegion = this._chatTabLayout.chatContactsRegion;
                        break;
                    case CP_CONST.CHAT_TAB_STATES.CHAT_WINDOW:
                        showRegion = this._chatTabLayout.chatWindowRegion;
                        break;
                }

                this._chatChannel.vent.trigger("cpChatUI::layout:survey:close", {showRegion: showRegion});
            },

            _getChatTabState: function () {
                return this._chatTabState;
            },

            _showChatSurveyRegion: function (options) {
                if (this._isValidShowRegionOptions(options)) {
                    this._showRegion(this._chatTabLayout.chatSurveyRegion, options.view);
                }
            },

            _showChatWindowRegion: function (options) {
                if (this._isValidShowRegionOptions(options)) {
                    this._showRegion(this._chatTabLayout.chatWindowRegion, options.view);
                }
            },

            _showChatContactsRegion: function (options) {
                if (this._isValidShowRegionOptions(options)) {
                    this._showRegion(this._chatTabLayout.chatContactsRegion, options.view);
                }
            },

            _isValidShowRegionOptions: function (options) {
                return (options && options.view);
            },

            _showRegion: function (region, view) {
                if (this._chatTabLayout.getIsRendered()) {
                    region.show(view);
                }
                else {
                    this.listenTo(this._chatTabLayout, "render", function () {
                        region.show(view);
                    });
                }
            },

            _onChatTabError: function (data) {
                var errorMsg;

                switch (data.errorType) {
                    case CP_CONST.CHAT_ERROR_TYPES.UNAVAILABLE:
                        errorMsg = LE.translator.translate("LEConnection.chat.livePersonChatWidgetContactUnavailable");
                        break;
                    case CP_CONST.CHAT_ERROR_TYPES.SURVEY_INVALID:
                        errorMsg = LE.translator.translate("LEConnection.survey.validationError");
                        break;
                    case CP_CONST.CHAT_ERROR_TYPES.GROUP_NOT_FOUND:
                        errorMsg = LE.translator.translate("LEConnection.chat.requestTeamChat.notFound");
                        break;
                    default:
                        errorMsg = LE.translator.translate("LEConnection.chat.connection.error");
                        break;
                }

                logger.debug("chat error occurred, showing message: " + errorMsg, "ChatTabController._onChatError", data);

                LEConnection.notifier.showError(errorMsg);
            },

            _onAppLogout: function () {

                logger.debug("application log out is taking place", "ChatTabController._onAppLogout");
                this._chatChannel.vent.trigger("chat::logout");
            }
        });
    });

    return ChatTabController;
});
